export enum ContactComponentType {
    DistrictContact = 1,
    CampusContact = 2
}